module.exports = __webpack_public_path__ + "static/media/100euro.b72511f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/100euro.jpg
// module id = 932
// module chunks = 0